




















































































































































































import IGood from '@/store/models/IGood';
import IInboundDetail from '@/store/models/IInboundDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IListPalletType from '@/store/models/IListPalletType';
import IInbound from '@/store/models/IInbound';
import Snackbar from '@/components/shared/Snackbar.vue';
import moment from 'moment';

@Component({
    components: {
        Snackbar
    }
})
export default class InboundDetailDeliveryNotesDetailSelector extends Vue {
    menu2: boolean = false;
    searchInboundDetailDeliveryNotesDetail: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet', value: 'palletName' },
        { text: 'Pallet amount', value: 'palletsAmount' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Weight per pallet (Kg)', value: 'weight' },
        { text: 'Language', value: 'language' },
        { text: 'T1', value: 'documentation' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IInboundDetail = {
        id: "",
        idInbound: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        inDeliveryNote: 0,
        language: "",
        documentation: false,
        sku: "",
        casesLoss: 0,
        weight: 0,
        goodCode: ""

    }
    defaultItem : IInboundDetail = {
        id: "",
        idInbound: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        inDeliveryNote: 0,
        language: "",
        documentation: false,
        sku: "",
        casesLoss: 0,
        weight: 0,
        goodCode: ""
    }

    @Prop({ type: Array, required: true })
    InboundDetailDeliveryNotesDetailList !: IInboundDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    PalletTypesList !: IListPalletType[];
    @Prop()
    SelectedInbound !: IInbound;
    @Prop()
    value !: IInboundDetail[];

    selectedInboundDetailDeliveryNotesDetail : IInboundDetail[] = [];
    selectedGood : IGood = {} as IGood;
    selectedPallet : IListPalletType = {} as IListPalletType;
    bestBeforeDate: string = new Date().toISOString().substr(0, 10);
    maxCasesPerPallet : number = 0;
    maxPalletAmount : number = 0;
    manualWeightEdited: boolean = false;
    inboundWeight: number = 0;// peso que llega del inbound (si > 0, se respeta)
    baseGoodWeight: number | null = null; // peso por caja/unidad del good (si viene en el item)
    needsPalletUpdate: boolean = false;
    casesChanged: boolean = false;
    palletsChanged: boolean = false;
    
    get formTitle() { return this.editedIndex === -1 ? 'New Inbound Detail Delivery Note Detail' : 'Edit Inbound Detail Delivery Note Detail'; }

    @Watch('value')
    updateSelection(newValue : IInboundDetail[] | null) {
        if (newValue !== null) {
            if (newValue!.length === 0) {
                this.selectedInboundDetailDeliveryNotesDetail = [];
            }
        }
    }
    @Watch('editedItem.casesPerPallet')
    onCasesPerPalletChanged() {
        this.casesChanged = true;
        // Si el usuario ya tocó el peso manualmente, no recalculamos el peso
        if (this.manualWeightEdited) return;

        if (this.inboundWeight && this.inboundWeight > 0) return;

        if (this.baseGoodWeight && this.baseGoodWeight > 0) {
            this.editedItem.weight = (Number(this.editedItem.casesPerPallet) || 0) * this.baseGoodWeight;
        } else {
            this.editedItem.weight = 0;
        }
    }
    @Watch('editedItem.palletsAmount')
    onPalletsAmountChanged() {
        this.palletsChanged = true;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    loanMin(value : number, fieldName : string) {
        return (value || "") >= 0 || `${fieldName} must be at least 0`;
    }

    GetValue(documentationNeeded : boolean) {
        if (documentationNeeded !== null && documentationNeeded !== undefined) {
            if (documentationNeeded.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }
    }

    @Watch('selectedInboundDetailDeliveryNotesDetail')
    onChangeSelectedInboundDetailDeliveryNotesDetail() {
        if (this.selectedInboundDetailDeliveryNotesDetail.length > 0) {
            this.$emit('input', this.selectedInboundDetailDeliveryNotesDetail);
        } else {
            this.$emit('input', null);
        }
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.SelectedInbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    getFilteredInboundDetailDeliveryNotesDetail(): IInboundDetail[] {
        if (!this.InboundDetailDeliveryNotesDetailList || this.InboundDetailDeliveryNotesDetailList.length === 0) {
            return [];
        }

        return this.InboundDetailDeliveryNotesDetailList.filter(i => {
            const totalCases = Number(i.totalCases) || 0;
            const inDeliveryNote = Number(i.inDeliveryNote) || 0;
            const availableCases = totalCases - inDeliveryNote;

            // Mostrar la línea si:
            // 1️⃣ Hay cajas aún disponibles (availableCases > 0)
            // 2️⃣ O bien el pallet ya tiene cantidad (caso de edición)
            return availableCases > 0 || (i.palletsAmount && i.palletsAmount > 0);
        });
    }

    CalculateCases() {
        if (this.editedItem.palletsAmount > 0 && this.editedItem.casesPerPallet > 0) {
            this.editedItem.totalCases = this.editedItem.palletsAmount * this.editedItem.casesPerPallet;
        }
    }

    CalculateGoods() {
        if (this.editedItem.totalCases > 0 && this.editedItem.goodsPerCase > 0) {
            this.editedItem.totalGoods = this.editedItem.totalCases * this.editedItem.goodsPerCase;
        }
    }

    editInboundDetailDeliveryNotesDetail(item: any, dbox = true) {
        this.editedIndex = this.InboundDetailDeliveryNotesDetailList.indexOf(item);
        this.maxCasesPerPallet = item.casesPerPallet;
        this.maxPalletAmount = item.palletsAmount;

        this.editedItem = Object.assign({}, item);

        // Guardamos el peso que llega del inbound (si > 0 se respeta SIEMPRE)
        this.inboundWeight = Number(item.weight) || 0;

        // Si la doc venía null, normalizamos
        if (this.editedItem.documentation === null) {
            this.editedItem.documentation = false;
        }

        // Intentamos detectar si nos llega el peso base del good en el propio item (campo opcional del DTO)
        // Si no existe en tu backend, quedará en null y no se podrá calcular
        this.baseGoodWeight = (item.goodWeight && item.goodWeight > 0) ? Number(item.goodWeight) : null;

        if (this.inboundWeight > 0) {
            // Respetamos el peso que ya viene del inbound (p.e. 980 Kg)
            this.editedItem.weight = this.inboundWeight;
        } else if (this.baseGoodWeight && this.baseGoodWeight > 0) {
            // No hay peso de inbound; calculamos con peso base del good si lo tenemos
            const cases = Number(this.editedItem.casesPerPallet) || 0;
            this.editedItem.weight = cases * this.baseGoodWeight;
        } else {
            // No hay forma de calcular → 0
            this.editedItem.weight = 0;
        }

        this.manualWeightEdited = false;
        this.dialog = true;
    }

    resetInboundDetailDeliveryNotesDetail() {
        this.selectedInboundDetailDeliveryNotesDetail = [];
    }

    saveInboundDetailDeliveryNotesDetail() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            // 🚫 Si el usuario cambió "cases per pallet" pero no "pallet amount", no permitir guardar
            if (this.casesChanged && !this.palletsChanged) {
                this.showMessageWarning("You must update the number of pallets after changing 'Cases per pallet'.");
                return;
            }

            // 🚫 Validar pallets > 0
            if (this.editedItem.palletsAmount <= 0) {
                this.showMessageWarning("Pallet amount must be greater than 0 to save.");
                return;
            }

            // ✅ Si todo está correcto → guardar
            this.editedItem.bestBeforeDate = new Date(this.bestBeforeDate);
            const index = this.InboundDetailDeliveryNotesDetailList.findIndex(i => i.id === this.editedItem.id);
            if (index !== -1) {
                Object.assign(this.InboundDetailDeliveryNotesDetailList[index], this.editedItem);
            }

            this.$emit('updateInboundDetailDeliveryNotesDetail', this.editedItem);
            this.close();
        } else {
            this.showMessageWarning("Please, some fields have not passed validation.");
        }
    }
  
    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.needsPalletUpdate = false;
        });
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
